import { useContext, useMemo } from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { QuestionMark } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../Contexts/AppContext";
import { RouteObject } from "react-router-dom";
import { NavigationItemsProps } from "./types";
import { UserRole } from "../../../models/User";

type routeObject = {
	name: string;
	path: string;
	display: () => boolean;
	ownFunction?: () => void;
};

export default function NavigationItems(props: NavigationItemsProps) {
	const { handleClose } = props;
	const navigate = useNavigate();

	const { title, setTitle, userContext, setUserContext } =
		useContext(AppContext);

	const routes = useMemo(() => {
		let routes: routeObject[] = [
			{
				name: "Inicio de Sesion",
				path: "/login",
				display: () => true,
				ownFunction: () => {
					setTitle("Inicio de Sesion");
					navigate("/login");
				},
			},
		];

		if (userContext) {
			routes = [
				{
					name: "Dispositivos",
					path: "/devices",
					display: () => true,
					ownFunction: () => {
						setTitle("Dispositivos");
						navigate("/devices");
					},
				},
				// {
				// 	name: "Conectividad",
				// 	path: "/connectivity-report",
				// 	display: () => true,
				// 	ownFunction: () => {
				// 		navigate("/connectivity-report");
				// 	},
				// },
				{
					name: "Usuarios",
					path: "/users",
					display: () => true,
					ownFunction: () => {
						setTitle("Usuarios");
						navigate("/users");
					},
				},
				{
					name: "Notificaciones",
					path: "/notifications",
					display: () => true,
					ownFunction: () => {
						setTitle("Notificaciones");
						navigate("/notifications");
					},
				},
				{
					name: "Configuracion",
					path: "/supplier/configuration",
					display: () => {
						return userContext.role === UserRole.ADMIN;
					},
					ownFunction: () => {
						setTitle("Configuracion Permisionario");
						navigate("/supplier/configuration");
					},
				},
				{
					name: "Cerrar Sesion",
					path: "/login",
					display: () => {
						return true;
					},
					ownFunction: () => {
						setUserContext(null);
						localStorage.removeItem("accessToken");
						setTitle("Inicio de Sesion");
						navigate("/login");
					},
				},
			];
		}

		return routes;
	}, [userContext]);
	return (
		<List sx={{ flex: 0.99999 }}>
			{routes.map((route, index) => (
				<>
					{route.display() ? (
						<ListItem key={route.path} disablePadding>
							<ListItemButton
								sx={{ textAlign: "center" }}
								onClick={() => {
									if (route.ownFunction) route.ownFunction();
									else navigate(route.path);

									handleClose();
								}}>
								<ListItemText
									sx={{ color: "white", textAlign: "center" }}
									primary={route.name}
								/>
							</ListItemButton>
						</ListItem>
					) : null}
				</>
			))}
		</List>
	);
}
